module.exports = __webpack_public_path__ + "img/Jump Casting72.bf6af5cb.jpg";